define(['modules/common/controls/control'], (Control) => Control.extend({

    tagName: 'label',

    binders: {
        required (view, value) {
            view.$el.toggleClass('required', Boolean(value));
        }
    },

    render () {
        Control.prototype.render.apply(this, arguments);
        this.$el.html(this.options.controlHtml);
        this.$el.toggleClass('required', Boolean(this.options.required));
        return this;
    }
}));
